import { render } from "./BasketPopover.vue?vue&type=template&id=629e9f7b&scoped=true"
import script from "./BasketPopover.vue?vue&type=script&lang=js"
export * from "./BasketPopover.vue?vue&type=script&lang=js"

import "./BasketPopover.vue?vue&type=style&index=0&id=629e9f7b&lang=scss&scoped=true"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-629e9f7b"]])

export default __exports__